export const CV_PATH = '/cv/new';
